
import React from 'react';
import { useCountry } from '@/contexts/CountryContext';

const EducationHeader = () => {
  const { countryName } = useCountry();
  
  return (
    <div className="max-w-3xl mx-auto text-center mb-10">
      <h1 className="text-3xl md:text-4xl font-bold text-nation-blue mb-4">
        Civic Education Hub
      </h1>
      <p className="text-gray-700">
        Explore our collection of podcasts, videos, and document summaries to deepen your understanding of important {countryName ? `${countryName}` : 'national'} issues, policies, and referendums.
      </p>
    </div>
  );
};

export default EducationHeader;
